import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13cd9b86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "detail-item" }
const _hoisted_3 = { class: "detail-item" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "detail-item" }
const _hoisted_6 = { class: "detail-item" }
const _hoisted_7 = { class: "detail-item" }
const _hoisted_8 = { class: "detail-item" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { key: 3 }
const _hoisted_13 = { key: 4 }
const _hoisted_14 = { key: 5 }
const _hoisted_15 = { key: 6 }
const _hoisted_16 = { class: "detail-item" }

import { t } from '@/plugins/i18n'
import { ref, reactive } from 'vue'
import { getJapanTime } from '@/util/common'
import { formatPrice, plusPrice, reducePrice, platformOrderItemSettleTypeDict } from '../data_old'
import { isMultiStore } from '@/store'
import { showCurrentUnit } from '@/util/useYan'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  rowName: {
    type: String,
    default: ''
  },
  rowItemDetail: {
    type: Object,
    default: () => ({})
  },
  type: {
    type: Number,
    default: 1
  }
},
  setup(__props) {




return (_ctx: any,_cache: any) => {
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createBlock(_component_el_scrollbar, { height: "500px" }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("p", _hoisted_2, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('费用类型')) + "：", 1),
            _createElementVNode("span", null, _toDisplayString(__props.rowName) + "(" + _toDisplayString(__props.rowItemDetail?.bizContentCustomer) + ")", 1)
          ]),
          _createElementVNode("p", _hoisted_3, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('可用余额')) + "：", 1),
            _createElementVNode("span", null, _toDisplayString(_unref(formatPrice)(__props.rowItemDetail?.afterAvailableAmount)) + _toDisplayString(_unref(showCurrentUnit)(_unref(isMultiStore)() && __props.rowItemDetail?.currencyCode === 'KRW')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('发货单号')) + "：", 1),
            _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail?.additionSettlementDeliveryRespDTO.deliveryTaskCode), 1)
          ]),
          _createElementVNode("p", _hoisted_6, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('日期')) + "：", 1),
            _createElementVNode("span", null, _toDisplayString(_unref(getJapanTime)(__props.rowItemDetail?.createTime)), 1)
          ])
        ]),
        _createElementVNode("p", _hoisted_7, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('单价')) + "：", 1),
          _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail?.additionSettlementDeliveryRespDTO.cost ?? 0) + _toDisplayString(_unref(showCurrentUnit)(_unref(isMultiStore)() && __props.rowItemDetail?.currencyCode === 'KRW')), 1)
        ]),
        _createElementVNode("p", _hoisted_8, [
          (__props.rowItemDetail?.additionSettlementDeliveryRespDTO.additionCode === 23)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(t)('纸箱总数量')) + "：", 1))
            : (__props.rowItemDetail?.additionSettlementDeliveryRespDTO.additionCode === 24)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_unref(t)('装箱总数量')) + "：", 1))
              : (__props.rowItemDetail?.additionSettlementDeliveryRespDTO.additionCode === 25)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(t)('气泡膜总数量')) + "：", 1))
                : (__props.rowItemDetail?.additionSettlementDeliveryRespDTO.additionCode === 27)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_unref(t)('托盘总数量')) + "：", 1))
                  : (__props.rowItemDetail?.additionSettlementDeliveryRespDTO.additionCode === 44)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_unref(t)('箱子总数量')) + "：", 1))
                    : (__props.rowItemDetail?.additionSettlementDeliveryRespDTO.additionCode === 52)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_unref(t)('箱子总数量')) + "：", 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_unref(t)('结算总数量')) + "：", 1)),
          _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail?.additionSettlementDeliveryRespDTO?.num ?? 0), 1)
        ]),
        _createElementVNode("p", _hoisted_16, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('结算总价')) + "：", 1),
          _createElementVNode("span", null, _toDisplayString(_unref(reducePrice)(__props.rowItemDetail?.additionSettlementDeliveryRespDTO?.money ?? 0)) + _toDisplayString(_unref(showCurrentUnit)(_unref(isMultiStore)() && __props.rowItemDetail?.currencyCode === 'KRW')), 1)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})